import * as React from 'react';
import { Input, Label, NumberField, TextField } from '@heroui/react';
import type { TextQuestion } from '../types';

export interface TextControlProps {
  question: TextQuestion;
  disabled?: boolean;
  onUpdate: (updates: Partial<TextQuestion>) => void;
}

export function TextControl({ question, disabled, onUpdate }: TextControlProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <TextField className="w-full" isDisabled={disabled}>
          <Label htmlFor={`text-placeholder-${question.id}`}>占位符文本</Label>
          <Input
            id={`text-placeholder-${question.id}`}
            value={question.placeholder ?? ''}
            onChange={(e) => onUpdate({ placeholder: e.target.value })}
            placeholder="请输入占位符文本"
          />
        </TextField>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">最小长度</div>
          <NumberField
            value={question.minLength ?? 0}
            onChange={(v) => onUpdate({ minLength: Number.isFinite(v) ? v : 0 })}
            minValue={0}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
        <div className="space-y-2">
          <div className="text-sm font-medium text-foreground">最大长度</div>
          <NumberField
            value={question.maxLength ?? 0}
            onChange={(v) => onUpdate({ maxLength: Number.isFinite(v) ? v : 0 })}
            minValue={1}
            isDisabled={disabled}
          >
            <NumberField.Group>
              <NumberField.DecrementButton />
              <NumberField.Input />
              <NumberField.IncrementButton />
            </NumberField.Group>
          </NumberField>
        </div>
      </div>
    </div>
  );
}
